import React from "react";
import {
  FaUser,
  FaHeart,
  FaComment,
  FaBell,
  FaCheckCircle,
} from "react-icons/fa";
import ProfileSidebar from "../component/ProfileSidebar"; 
import PageCount from "../component/utils/PageCount";

const Notification = () => {
  const notifications = [
    {
      id: 1,
      type: "connection",
      icon: <FaUser />,
      message: "Aarohi Sharma viewed your profile.",
      time: "2 mins ago",
      avatar:
        "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      id: 2,
      type: "like",
      icon: <FaHeart />,
      message: "Riya Kapoor liked your recent post.",
      time: "15 mins ago",
      avatar:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      id: 3,
      type: "comment",
      icon: <FaComment />,
      message: "Arjun Patel commented: “Looking great!”",
      time: "1 hr ago",
      avatar:
        "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      id: 4,
      type: "system",
      icon: <FaBell />,
      message: "Your membership has been successfully renewed.",
      time: "3 hrs ago",
      avatar: null,
    },
    {
      id: 5,
      type: "connection",
      icon: <FaCheckCircle />,
      message: "You are now connected with Meera Jain.",
      time: "1 day ago",
      avatar:
        "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
  ];

  return (
    <div className="view-profile-page d-flex">
      <ProfileSidebar />
<PageCount pageName = {"Notification"}/>
      <div className="notification-container container flex-grow-1 p-3 ">
        <div className="notification-header d-flex align-items-center justify-content-between mb-4">
          <h4 className="fw-bold mb-0">Notifications</h4>
          <button className="btn clear-btn">Clear All</button>
        </div>

        <div className="notifications-list">
          {notifications.map((note) => (
            <div key={note.id} className={`notification-card ${note.type}`}>
              <div className="icon-badge">{note.icon}</div>
              {note.avatar && (
                <img src={note.avatar} alt="avatar" className="notification-avatar" />
              )}
              <div className="notification-content">
                <p className="mb-1">{note.message}</p>
                <small className="text-muted">{note.time}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Notification;
